import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { CrudTable, type FieldDef } from "@/features/admin/components/CrudTable";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/lessons")({
  component: AdminLessons,
});

function AdminLessons() {
  const [courses, setCourses] = useState<{ value: string; label: string }[] | null>(null);

  useEffect(() => {
    supabase
      .from("courses")
      .select("id,name")
      .order("name")
      .then(({ data }) =>
        setCourses((data ?? []).map((r) => ({ value: r.id as string, label: r.name as string }))),
      );
  }, []);

  if (!courses)
    return (
      <div className="flex justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );

  const fields: FieldDef[] = [
    { key: "title", label: "العنوان", required: true },
    { key: "course_id", label: "الكورس", type: "select", options: courses, required: true },
    { key: "description", label: "وصف قصير", type: "textarea" },
    { key: "content", label: "المحتوى", type: "textarea" },
    { key: "video_url", label: "رابط الفيديو" },
    { key: "sort_order", label: "الترتيب", type: "number", defaultValue: 0 },
    { key: "points_reward", label: "نقاط المكافأة", type: "number", defaultValue: 10 },
    { key: "is_published", label: "منشور", type: "switch", defaultValue: true },
  ];

  return (
    <CrudTable
      title="Lessons"
      table="lessons"
      fields={fields}
      orderBy={{ column: "sort_order", ascending: true }}
      columns={[
        { key: "title", label: "Title" },
        {
          key: "course_id",
          label: "Course",
          render: (r) => courses.find((c) => c.value === r.course_id)?.label || "—",
        },
        { key: "sort_order", label: "Order" },
        { key: "points_reward", label: "Points" },
        { key: "is_published", label: "Published", render: (r) => (r.is_published ? "✓" : "✗") },
      ]}
    />
  );
}
